module.exports = __webpack_public_path__ + "img/google_icon.45aebcf8.svg";